/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftOwnershipWithWallet } from './NftOwnershipWithWallet';
import {
    NftOwnershipWithWalletFromJSON,
    NftOwnershipWithWalletFromJSONTyped,
    NftOwnershipWithWalletToJSON,
    NftOwnershipWithWalletToJSONTyped,
} from './NftOwnershipWithWallet';

/**
 * 
 * @export
 * @interface GetNftOwnershipsResponse
 */
export interface GetNftOwnershipsResponse {
    /**
     * 
     * @type {Array<NftOwnershipWithWallet>}
     * @memberof GetNftOwnershipsResponse
     */
    nftOwnerships: Array<NftOwnershipWithWallet>;
}

/**
 * Check if a given object implements the GetNftOwnershipsResponse interface.
 */
export function instanceOfGetNftOwnershipsResponse(value: object): value is GetNftOwnershipsResponse {
    if (!('nftOwnerships' in value) || value['nftOwnerships'] === undefined) return false;
    return true;
}

export function GetNftOwnershipsResponseFromJSON(json: any): GetNftOwnershipsResponse {
    return GetNftOwnershipsResponseFromJSONTyped(json, false);
}

export function GetNftOwnershipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftOwnershipsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftOwnerships': ((json['nftOwnerships'] as Array<any>).map(NftOwnershipWithWalletFromJSON)),
    };
}

export function GetNftOwnershipsResponseToJSON(json: any): GetNftOwnershipsResponse {
    return GetNftOwnershipsResponseToJSONTyped(json, false);
}

export function GetNftOwnershipsResponseToJSONTyped(value?: GetNftOwnershipsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftOwnerships': ((value['nftOwnerships'] as Array<any>).map(NftOwnershipWithWalletToJSON)),
    };
}

